<div class="card-white">
  <ng-container *ngIf="formPrincipal">
    <div class="card-header mb-4">
      <div class="title-section">
        <h2 class="header-title">
          {{ model ? 'Editar Promoción' : 'Agregar Promoción' }}
        </h2>
      </div>
      <div class="button-section" *ngIf="!loading">
        <button mat-flat-button (click)="model ? update() : create()" class="btn-new" type="submit" [disabled]="!form.valid" appPermissionControl="P150B0001">
          <mat-icon>save</mat-icon>
          {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button mat-flat-button (click)="close()" class="btn-back" appPermissionControl="P150B0002">
          <mat-icon>arrow_back</mat-icon>
          Atrás
        </button>
      </div>
    </div>

    <form [formGroup]="form" (submit)="model ? update(form.value) : create(form.value)" appPermissionControl="P150F0001">
      <div class="card-white">
        <div class="form-row">
          <div class="form-field">
            <input id="sPromocion" type="text" class="form-control" formControlName="sPromocion" [readonly]="model" required appPermissionControl="P150K0001" />
            <label>Promoción:</label>
          </div>
          <div class="form-field">
            <input class="form-control" formControlName="descripcion" required appPermissionControl="P150K0002" />
            <label>Descripción</label>
          </div>
        </div>

        <hr style="width: 200px; margin-top: 0px" />

        <div class="form-row">
          <!-- Compañia -->
          <div class="form-field flex-grow-1">
            <select class="form-control" formControlName="sEmpresa" (change)="readSucursales($event.target.value)" appPermissionControl="P150K0003">
              <option value>-- Seleccione --</option>
              <option *ngFor="let empresa of empresas" [value]="empresa.sEmpresa">{{ empresa.sEmpresa }} | {{ empresa.sNombre }}</option>
            </select>
            <label>Compañía</label>
          </div>

          <!-- Clase Cartera -->
          <div class="form-field flex-grow-1">
            <select class="form-control" formControlName="claseCart" appPermissionControl="P150K0004">
              <option value="">-- Seleccione --</option>
              <option *ngFor="let claseCartera of claseCarteras" [value]="claseCartera.iValor">{{ claseCartera.iValor }} | {{ claseCartera.sEtiqueta }}</option>
            </select>
            <label>Clase Cartera:</label>
          </div>

          <!-- Sucursal -->
          <div class="form-field">
            <select class="form-control" formControlName="sSucursal" appPermissionControl="P150K0005">
              <option value="">-- Seleccione --</option>
              <option *ngFor="let sucursal of sucursales" [value]="sucursal.sSucursal">{{ sucursal.sSucursal }} | {{ sucursal.nombre_Sucursal }}</option>
              <option *ngIf="sucursales?.length == 0">La empresa no tiene sucursales</option>
            </select>
            <label>Sucursal:</label>
          </div>

          <!-- Tipo Credito -->
          <div class="form-field">
            <select class="form-control" formControlName="producto" appPermissionControl="P150K0006">
              <option value="">-- Seleccione --</option>
              <option *ngFor="let producto of productos" [value]="producto.producto">{{ producto.producto }} | {{ producto.descripcion }}</option>
            </select>
            <label>Tipo Producto:</label>
          </div>

          <!-- Moneda -->
          <div class="form-field">
            <select class="form-control" formControlName="moneda" appPermissionControl="P150K0007">
              <option value="">-- Seleccione --</option>
              <option *ngFor="let moneda of monedas" [value]="moneda.moneda">{{ moneda.moneda }} | {{ moneda.descripcion }}</option>
            </select>
            <label>Moneda:</label>
          </div>

          <!-- Tipo Cartera -->
          <div class="form-field">
            <select class="form-control" formControlName="sCartera" appPermissionControl="P150K0008">
              <option value="">-- Seleccione --</option>
              <option *ngFor="let tipoCartera of tipoCarteras" [value]="tipoCartera.sCartera">{{ tipoCartera.sCartera }} | {{ tipoCartera.descripcion }}</option>
            </select>
            <label>Tipo Cartera:</label>
          </div>
        </div>

        <div class="form-row">
          <!-- Plazo Mínimo -->
          <div class="form-field">
            <input type="number" class="form-control" formControlName="plazoMin" appPermissionControl="P150K0009" />
            <label>Plazo Mínimo</label>
          </div>

          <!-- Fecha Inicial -->
          <div class="form-field">
            <input type="date" class="form-control" formControlName="sFechaI" appPermissionControl="P150K0010" />
            <label>Fecha Inicial</label>
          </div>
        </div>

        <div class="form-row">
          <!-- Plazo Máximo -->
          <div class="form-field">
            <input class="form-control" formControlName="plazoMax" type="number" required appPermissionControl="P150K0011" />
            <label>Plazo Máximo</label>
          </div>

          <!-- Fecha Final -->
          <div class="form-field">
            <input class="form-control" formControlName="sFechaF" type="date" appPermissionControl="P150K0012" />
            <label>Fecha Final</label>
          </div>
        </div>
      </div>

      <hr />

      <div style="display: flex; flex-direction: column; gap: 15px" *ngIf="model">
        <div class="titleFm" style="width: 200px">Funciones</div>
        <div class="content-funciones row g-3" style="padding: 30px">
          <mat-card-actions *ngFor="let fun of functions" class="col-3">
            <button mat-raised-button (click)="toLink(fun)" class="content-funciones-item" appPermissionControl="P150B0003">
              {{ fun.name }}
            </button>
          </mat-card-actions>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="selectEmpresa">
    <button mat-button color="accent" class="buttonBack" type="button" (click)="changeBoolean('form')" appPermissionControl="P150B0004"><mat-icon>west</mat-icon> Regresar</button>
    <app-select-empresa></app-select-empresa>
  </ng-container>

  <ng-container *ngIf="selectMoneda">
    <button mat-button color="accent" class="buttonBack" type="button" (click)="changeBoolean('form')" appPermissionControl="P150B0005"><mat-icon>west</mat-icon> Regresar</button>
    <app-select-moneda></app-select-moneda>
  </ng-container>
</div>
